import { SentryFilter } from 'sentryFilters/types'

export const browserBugFilters: SentryFilter[] = [
  {
    name: 'safari-notreadable-error',
    description: 'Safari bfcache restoring closed fetch streams',
    match: (event, hint) => {
      const msg = (hint?.originalException as Error)?.message || ''
      return msg.includes('NotReadableError') || msg.includes('I/O read operation failed')
    },
  },
]
